exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".perf-tool .right-hand{position:absolute;top:0;right:0;bottom:0;left:200px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/styles/right-hand.css
 ** module id = 212
 ** module chunks = 0
 **/